import React from 'react';
import CardDropdown from 'components/common/CardDropdown';
import FalconCardHeader from 'components/common/FalconCardHeader';
import createMarkup from 'helpers/createMarkup';
import { Card, Col, ProgressBar, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { shoppingCartItems } from 'data/weraise-data/data';

const ShoppingCartItem = ({ item, index }) => {
  const { id, title, amount, barWidth, items, variant, icon, iconColor } = item;
  return (
    <Row
      className={classNames('g-0 align-items-center pb-4 mb-1', {
        'border-top pt-4': index !== 0
      })}
    >
      <Col className="pe-4">
        <h6 className="fs--2 text-600">{title}</h6>

        <ProgressBar className="mt-xxl-auto" style={{ height: 5 }}>
          <ProgressBar
            variant={variant}
            now={barWidth}
            key={id}
            className="rounded-3"
          />
        </ProgressBar>
      </Col>
      <Col xs="auto" className="text-end">
        <p className="mb-0 text-900 font-sans-serif">
          {icon && (
            <FontAwesomeIcon icon={icon} className={`text-${iconColor} me-1`} />
          )}
          {amount}%
        </p>
        <p
          className="mb-0 fs--2 text-500 fw-semi-bold"
          dangerouslySetInnerHTML={createMarkup(items)}
        />
      </Col>
    </Row>
  );
};

const ShoppingCart = ({
  data = shoppingCartItems,
  title = 'Shopping Cart'
}) => {
  return (
    <Card className="h-100">
      <FalconCardHeader
        title={title}
        titleTag="h6"
        className="py-3"
        endEl={<CardDropdown btnRevealClass="btn-falcon-default" />}
      />
      <Card.Body className="py-0 d-flex align-items-center h-100">
        <div className="flex-1">
          {data?.map((item, index) => (
            <ShoppingCartItem item={item} key={item.id} index={index} />
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

ShoppingCart.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired
};
ShoppingCartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    barWidth: PropTypes.number.isRequired,
    items: PropTypes.string.isRequired,
    iconColor: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    icon: PropTypes.string
  }),
  index: PropTypes.number.isRequired
};

export default ShoppingCart;
